import React from 'react'
import cn from 'classnames'
import { Link as NoHttpLink } from 'react-router-dom'

import st from './index.scss'

export default function Link({ className, to, useorigin, children, ...props }) {
    let str = to
    // 如果不是字符串，就是一个对象
    if (typeof str !== 'string') {
        str = to.pathname
    }

    if (str.indexOf('http') !== -1 || useorigin) {
        return <a className={cn(st['a'], className)} {...props} href={str}>{children}</a>
    }

    return <NoHttpLink className={cn(st['a'], className)} to={to} {...props}>{children}</NoHttpLink>
}
